<template>
  <el-dialog
      v-el-drag-dialog
      append-to-body
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印标签条码"
      class="materialCodeModal"
      width="800px"
      top="0">
    <div v-for="(item, index) in tableData" id="printMaterialCode2" :key="index">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <td>
            <div :id="'qrCode2' + item.itemSn" align="center"/>
          </td>
        </tr>
        <tr>
          <td colspan="2" style=" font-size:15px;text-align: center;">{{productInfo.specification}}</td>
        </tr>
      </table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";

  export default {
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        productInfo: {},
      };
    },

    methods: {
      open(codeList, productInfo) {
        this.dialogVisible = true;
        this.tableData = codeList;
        this.productInfo = productInfo;
        for (let item of this.tableData) {
          const itemSn = item.itemSn;
          this.$nextTick(() => {
            document.getElementById("qrCode2" + itemSn).innerHTML = "";
            this.bindQRCode(itemSn);
          });
        }
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode2" + row), {
          text: this.productInfo.billNo+"-NO:"+text,
          width: 90,
          height: 90,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("printMaterialCode2").parentNode.innerHTML;
        window.print();
        window.location.reload();
        this.$http.get("basic", `taskDispatchBills/updatePrintSn/${this.productInfo.pkid}`).then(() => {
        });
        return false;
      },
    },
  };
</script>
<style lang="scss" scoped>
.materialCodeModal .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.materialCodeModal .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.materialCodeModal .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 39px;
  height: 90%;
}

.materialCodeModal .el-divider--horizontal {
  margin: 10px 0;
}

.materialCodeModal .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style lang="scss" scoped>
#printMaterialCode2 {
  width: 76mm;
  height: 36mm;
  margin: 0 auto;
  margin-top: 1.5mm;
  page-break-before: always;
  font-size: 10px;

  table {
    width: 100%;
    height: 100%;

    td {
      border: 1px solid #111;
      border-bottom: 0;
      border-right: 0;
      padding: 1mm;
      box-sizing: border-box;
      height: 7mm;
    }

    tr:first-child td:first-child {
      border-bottom: 1px solid #111;
    }

    tr:last-child td {
      border-bottom: 1px solid #111;
    }

    tr td:last-child {
      border-right: 1px solid #111;
    }
  }
}
</style>
